
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeLaborGrid extends Serenity.EntityGrid<ExchangeLaborRow, any> {
        protected getColumnsKey() { return 'Retail.ExchangeLabor'; }
        protected getIdProperty() { return ExchangeLaborRow.idProperty; }
        protected getInsertPermission() { return ExchangeLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return ExchangeLaborRow.localTextPrefix; }
        protected getService() { return ExchangeLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}